import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  PermissionedProductTier,
  PermissionedProductTierName,
} from '@rivethealth/data/rivet-product';
import { isEqual } from 'lodash';

@Injectable()
export class ProductsState {
  readonly tiers: PermissionedProductTier[] =
    this.route.snapshot.data['products'].tiers;

  public hasTier(tierName: PermissionedProductTierName): boolean {
    return this.tiers.some(t => t.name === tierName);
  }

  public hasOnlyTier(tierName: PermissionedProductTierName): boolean {
    return isEqual(this.tiers, [tierName]);
  }

  constructor(private readonly route: ActivatedRoute) {}
}

export function useHasTier(
  state: ProductsState,
  tiers: PermissionedProductTierName[],
): boolean {
  return tiers.some(t => state.hasTier(t));
}
